import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { toolkitCx } from "../../../constants";
import Checkbox from "../../atoms/Checkbox";
/**
 * Renders a legal checkbox that can be used in consent forms.
 *
 * @param {ILegalCheckboxProps} props - Component props.
 * @param {boolean} props.isLegalChecked - Whether the checkbox is checked.
 * @param {function} props.onLegalClick - Function called when the checkbox is clicked.
 * @param {boolean} [props.showErrorFlash] - Whether to show an error flash if the checkbox is not checked.
 * @param {ReactNode} [props.children] - Optional children to be rendered inside the checkbox wrapper.
 * @param {string} [props.className] - Optional class name to apply to the checkbox wrapper.
 * @param {string} [props.id] - Optional ID to apply to the checkbox wrapper.
 * @param {string} [props.innerClassName] - Optional class name to apply to the checkbox inner wrapper.
 * @param {any} [props.rest] - Optional additional props to pass to the checkbox wrapper.
 * @returns {JSX.Element} - The rendered component.
 */
const LegalCheckbox = ({ children, isLegalChecked, onLegalClick, showErrorFlash, innerClassName, ...wrapperProps }) => (_jsx("div", { ...wrapperProps, className: wrapperProps.className, children: _jsxs("div", { className: cx("flex flex-nowrap items-center gap-4", "relative cursor-pointer select-none rounded-lg", toolkitCx.layout.spacing.both.md, {
            "bg-gradient-to-br from-primary/20 via-primary/10 to-transparent": !isLegalChecked && !showErrorFlash,
            "bg-gradient-to-br from-success/30 via-success/20 to-success/10": isLegalChecked,
            "bg-gradient-to-br from-error/30 via-error/20 to-error/10": showErrorFlash,
        }, innerClassName), onClick: () => onLegalClick(!isLegalChecked), children: [_jsx(Checkbox, { checked: isLegalChecked }), children] }) }));
export default LegalCheckbox;
//# sourceMappingURL=LegalCheckbox.js.map